import {
  Box,
  Button,
  Chip,
  CircularProgress,
  ClickAwayListener,
  Divider,
  FormControl,
  MenuItem,
  Popper,
  Select,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import LineGraph from 'components/LineGraph/LineGraph';
import parse from 'html-react-parser';
import {
  Add,
  Check,
  CheckBox,
  CheckBoxOutlineBlank,
  CheckCircle,
  Close,
  Delete,
  HelpOutline,
  Redo,
  Sync,
  Troubleshoot,
  Warning,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  artifactFailedStatuses,
  artifactProcessingStatuses,
  artifactStatusMap,
  artifactTypesWithoutMedia,
} from 'utils';
import updateNextBestActions from 'redux/actions/Common/updateNextBestActions';

const NextBestActions = ({
  type,
  dealId,
  dealArtifactsLoading,
  noArtifacts,
  readOnly,
  activeArtifact,
  setCurrentArtifactDetailTab,
  setActiveArtifactTab,
  ...rest
}) => {
  const theme = useTheme();
  const history = useHistory();
  const pathParams = useParams();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [nextBestActions, setNextBestActions] = useState([]);
  const [activeNBA, setActiveNBA] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [hints, setHints] = useState([]);

  const [anchorElDetails, setAnchorElDetails] = useState(null);
  const [popperDetails, setPopperDetails] = useState(null);
  const [popperExplanation, setPopperExplanation] = useState(null);
  const [questionOrHintEditMode, setQuestionOrHintEditMode] = useState(null);
  const [editModeFor, setEditModeFor] = useState('');
  const [questionOrHintText, setQuestionOrHintText] = useState('');
  const [updatingQuestionOrHint, setUpdatingQuestionOrHint] = useState(false);

  const scrollTo = (id) => {
    setTimeout(() => {
      const element = document.querySelector(`#${id}`);
      if (!element) {
        return;
      }
      // console.log(element.offsetTop);

      window.scrollTo({
        left: 0,
        top: element.offsetTop + 400,
        behavior: 'smooth',
      });
    });
  };

  useEffect(() => {
    if (
      activeNBA &&
      activeNBA?.hintsAndQuestions &&
      activeNBA?.hintsAndQuestions?.length > 0
    ) {
      setHints(
        activeNBA?.hintsAndQuestions?.reduce((acc, curr) => {
          acc.push(...(curr?.hints || []));
          return acc;
        }, []),
      );
      setQuestions(
        activeNBA?.hintsAndQuestions?.reduce((acc, curr) => {
          acc.push(...(curr?.questions || []));
          return acc;
        }, []),
      );
    }
  }, [activeNBA]);

  useEffect(() => {
    if (activeArtifact) {
      setNextBestActions(activeArtifact?.nextBestActionsMap);
      setActiveNBA(activeArtifact?.nextBestActionsMap?.[0] || null);
    } else {
      setNextBestActions([]);
      setActiveNBA(null);
    }
  }, [activeArtifact]);

  // console.log(hints);
  // console.log(questions);

  return (
    <Box display={'flex'} flexDirection={'column'} gap={2} {...rest}>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          // border: '1px solid #d3d3d3',
          borderRadius: 2,
        }}
      >
        {dealArtifactsLoading ? (
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              // width: 1,
              paddingBottom: 10,
              // minHeight: 300,
              // maxHeight: 350,
              padding: readOnly ? 2 : 1,
              // border: readOnly ? 'none' : '1px solid #d3d3d3',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 2,
            }}
          >
            <CircularProgress size={20} />
            <Typography>Fetching Activities</Typography>
          </Box>
        ) : noArtifacts ? (
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              // width: 1,
              paddingBottom: 10,
              // minHeight: 300,
              // maxHeight: 350,
              padding: readOnly ? 2 : 1,
              // border: readOnly ? 'none' : '1px solid #d3d3d3',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 2,
            }}
          >
            <Typography color={'text.secondary'} mb={1}>
              No activity found. Guidance will be generated after activities are
              added.
            </Typography>
          </Box>
        ) : !activeArtifact ? (
          type === 'recent' ? (
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                // width: 1,
                paddingBottom: 10,
                // minHeight: 300,
                // maxHeight: 350,
                padding: readOnly ? 2 : 1,
                // border: readOnly ? 'none' : '1px solid #d3d3d3',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 2,
              }}
            >
              <Typography color={'text.secondary'} mb={1}>
                Next Best Actions are not generated yet.
              </Typography>
              {/* <Button
              variant="outlined"
              onClick={() => {
                setActiveArtifactTab('detail');
                setTimeout(() => {
                  setCurrentArtifactDetailTab('risk');
                  scrollTo('artifactRiskSelection');
                }, 100);
              }}
            >
              Generate Now
            </Button> */}
            </Box>
          ) : (
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                // width: 1,
                paddingBottom: 10,
                // minHeight: 300,
                // maxHeight: 350,
                padding: readOnly ? 2 : 1,
                // border: readOnly ? 'none' : '1px solid #d3d3d3',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 2,
              }}
            >
              <Typography color={'text.secondary'} mb={1}>
                Select an activity to see next best actions.
              </Typography>
            </Box>
          )
        ) : activeArtifact?.nextBestActionsMap &&
          activeArtifact?.nextBestActionsMap?.length > 0 ? (
          <>
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                // width: 1,
                // paddingBottom: 10,
                // minHeight: 300,
                // maxHeight: 300,
                overflowY: 'scroll',
                '&::-webkit-scrollbar': {
                  width: '5px',
                },
                '&::-webkit-scrollbar-track': {
                  boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                  webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: theme.palette.primary.main,
                  borderRadius: 2,
                },
                paddingBottom: 2,
                paddingRight: 2,
                // padding: readOnly ? 2 : 1,
                borderRadius: 2,
              }}
            >
              <Typography color={'text.secondary'} fontWeight={'bold'}>
                Next Best Actions
              </Typography>
              {nextBestActions?.map((action, index) => (
                <Box
                  key={index + 1}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: readOnly ? 'default' : 'pointer',
                    borderRadius: 2,
                    width: 1,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveNBA(action);
                  }}
                >
                  <Box
                    sx={{
                      background:
                        activeNBA?.id === action?.id ? '#C2DBFF' : '#F2F6FC',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 1,
                      flex: 1,
                      borderRadius: 2,
                      position: 'relative',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        flex: 1,
                        borderRadius: 2,
                        paddingLeft: 2,
                      }}
                    >
                      <Box
                        display={'flex'}
                        sx={{
                          width: 1,
                          padding: 1,
                          justifyContent: 'space-between',
                          gap: 2,
                          cursor: 'pointer',
                        }}
                      >
                        <Typography
                          sx={{
                            color:
                              activeNBA?.id === action?.id
                                ? theme.palette.primary.main
                                : theme.palette.text.primary,
                            textDecoration: action?.deleted
                              ? 'line-through'
                              : 'none',
                          }}
                          onMouseEnter={(e) => {
                            setAnchorElDetails(e.currentTarget);
                            setPopperDetails(action?.risksAddressed);
                            setPopperExplanation(action?.explanation);
                          }}
                          onMouseLeave={() => {
                            setAnchorElDetails(null);
                            setPopperDetails(null);
                            setPopperExplanation(null);
                          }}
                        >
                          {action?.action}
                        </Typography>
                        {/* <Box display={'flex'} alignItems={'center'} gap={1}>
                          {action?.done ? (
                            <Tooltip
                              arrow
                              placement="top"
                              title={'Mark as Undone'}
                            >
                              <CheckBox
                                sx={{
                                  color: theme.palette.primary.main,
                                  fontSize: 18,
                                  cursor: 'pointer',
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  dispatch(
                                    updateNextBestActions(
                                      dealId,
                                      activeArtifact?.id,
                                      action?.id,
                                      { done: false },
                                      () => {
                                        setNextBestActions((prev) => {
                                          return prev?.map((nba) => {
                                            if (nba?.id === action?.id) {
                                              return {
                                                ...nba,
                                                done: false,
                                              };
                                            }
                                            return nba;
                                          });
                                        });
                                      },
                                      () => {},
                                    ),
                                  );
                                }}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip
                              arrow
                              placement="top"
                              title={'Mark as Done'}
                            >
                              <CheckBoxOutlineBlank
                                sx={{
                                  color: theme.palette.text.secondary,
                                  fontSize: 18,
                                  cursor: 'pointer',
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  dispatch(
                                    updateNextBestActions(
                                      dealId,
                                      activeArtifact?.id,
                                      action?.id,
                                      { done: true },
                                      () => {
                                        setNextBestActions((prev) => {
                                          return prev?.map((nba) => {
                                            if (nba?.id === action?.id) {
                                              return {
                                                ...nba,
                                                done: true,
                                              };
                                            }
                                            return nba;
                                          });
                                        });
                                      },
                                      () => {},
                                    ),
                                  );
                                }}
                              />
                            </Tooltip>
                          )}
                          <Tooltip
                            arrow
                            placement="top"
                            title={action?.deleted ? 'Restore' : 'Remove'}
                          >
                            {action?.deleted ? (
                              <Redo
                                sx={{
                                  color: '#fff',
                                  cursor: 'pointer',
                                  fontSize: 16,
                                  position: 'absolute',
                                  top: -5,
                                  right: -5,
                                  background: 'rgba(128,105,191,0.5)',
                                  borderRadius: '50%',
                                  padding: '2px',
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  dispatch(
                                    updateNextBestActions(
                                      dealId,
                                      activeArtifact?.id,
                                      action?.id,
                                      { deleted: !action?.deleted },
                                      () => {
                                        setNextBestActions((prev) => {
                                          return prev?.map((nba) => {
                                            if (nba?.id === action?.id) {
                                              return {
                                                ...nba,
                                                deleted: !action?.deleted,
                                              };
                                            }
                                            return nba;
                                          });
                                        });
                                      },
                                      () => {},
                                    ),
                                  );
                                }}
                              />
                            ) : (
                              <Close
                                sx={{
                                  color: '#000',
                                  cursor: 'pointer',
                                  fontSize: 18,
                                  position: 'absolute',
                                  top: -5,
                                  right: -5,
                                  background: '#F2F6FC',
                                  borderRadius: '50%',
                                  border: '1px solid #C2DBFF',
                                  padding: '2px',
                                  zIndex: 1000,
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  dispatch(
                                    updateNextBestActions(
                                      dealId,
                                      activeArtifact?.id,
                                      action?.id,
                                      { deleted: !action?.deleted },
                                      () => {
                                        setNextBestActions((prev) => {
                                          return prev?.map((nba) => {
                                            if (nba?.id === action?.id) {
                                              return {
                                                ...nba,
                                                deleted: !action?.deleted,
                                              };
                                            }
                                            return nba;
                                          });
                                        });
                                      },
                                      () => {},
                                    ),
                                  );
                                }}
                              />
                            )}
                          </Tooltip>
                        </Box> */}
                      </Box>
                      <Popper
                        id="mouse-over-popover"
                        sx={{
                          pointerEvents: 'none',
                          zIndex: 1111111,
                        }}
                        open={Boolean(anchorElDetails)}
                        anchorEl={anchorElDetails}
                        placement="right"
                        onClose={() => {
                          setAnchorElDetails(null);
                        }}
                        // disableRestoreFocus
                      >
                        <Box
                          sx={{
                            border: '1px solid #d3d3d3',
                            borderRadius: 1,
                            padding: 1,
                            background: '#fff',
                            maxWidth: 400,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                            // boxShadow: theme.shadows[1],
                          }}
                        >
                          <Typography>
                            Risks addressed by this action:
                          </Typography>
                          <Box
                            display={'flex'}
                            alignItems={'center'}
                            gap={1}
                            flexWrap={'wrap'}
                          >
                            {popperDetails?.map((risk) => (
                              <Chip
                                key={risk?.id}
                                label={risk?.riskTitle}
                                size="small"
                                color="default"
                              />
                            ))}
                          </Box>
                          {/* {popperDetails?.map((risk) => ( */}
                          <Typography
                            variant={'body1'}
                            color={'text.secondary'}
                            sx={{
                              padding: 1,
                            }}
                          >
                            {popperExplanation || ''}
                          </Typography>
                          {/* ))} */}
                        </Box>
                      </Popper>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                // width: 1,
                // minHeight: 300,
                // maxHeight: 300,
                overflowY: 'scroll',
                '&::-webkit-scrollbar': {
                  width: '5px',
                },
                '&::-webkit-scrollbar-track': {
                  boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                  webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: theme.palette.primary.main,
                  borderRadius: 2,
                  // outline: '1px solid slategrey',
                },
                paddingX: 2,
                paddingBottom: 2,
                // padding: readOnly ? 2 : 1,
                // border: readOnly ? 'none' : '1px solid #d3d3d3',
                borderRadius: 2,
              }}
            >
              <Typography color={'text.secondary'} fontWeight={'bold'} mb={1}>
                Details
              </Typography>
              {questions?.map((question, index) => (
                <Box
                  key={index + 1}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: readOnly ? 'default' : 'pointer',
                    borderRadius: 2,
                    width: 1,
                    gap: 1,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <img
                    src="/dh-icons/question.svg"
                    width={'20px'}
                    height={'20px'}
                  />
                  <Box
                    sx={{
                      background: '#F2F6FC',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 1,
                      flex: 1,
                      borderRadius: 2,
                      position: 'relative',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        flex: 1,
                        borderRadius: 2,
                        paddingX: 2,
                      }}
                    >
                      {questionOrHintEditMode === question?.id ? (
                        <TextField
                          autoFocus
                          placeholder="Question"
                          variant="outlined"
                          color="primary"
                          size="small"
                          name="question"
                          multiline
                          rows={2}
                          value={questionOrHintText}
                          disabled={updatingQuestionOrHint}
                          onChange={(e) => {
                            setQuestionOrHintText(e.target.value);
                          }}
                          fullWidth
                        />
                      ) : (
                        <Box
                          display={'flex'}
                          flexDirection={'column'}
                          sx={{
                            width: 1,
                            padding: 1,
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography
                            sx={{
                              textDecoration: activeNBA?.deleted
                                ? 'line-through'
                                : 'none',
                            }}
                          >
                            {question?.cq}
                          </Typography>
                        </Box>
                      )}
                      {/* {activeNBA?.deleted ? null : (
                        <>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 2,
                            }}
                          >
                            {questionOrHintEditMode === question?.id ? (
                              updatingQuestionOrHint ? (
                                <CircularProgress size={20} />
                              ) : (
                                <>
                                  <Tooltip title="Cancel" arrow placement="top">
                                    <Close
                                      sx={{
                                        cursor: 'pointer',
                                        fontSize: 20,
                                      }}
                                      onClick={() => {
                                        setQuestionOrHintEditMode(null);
                                        setQuestionOrHintText('');
                                      }}
                                    />
                                  </Tooltip>
                                  <Tooltip title="Save" arrow placement="top">
                                    <Check
                                      sx={{
                                        cursor: 'pointer',
                                        fontSize: 20,
                                      }}
                                      onClick={() => {
                                        setUpdatingQuestionOrHint(true);
                                        dispatch(
                                          updateNextBestActions(
                                            dealId,
                                            activeArtifact?.id,
                                            activeNBA?.id,
                                            {
                                              hintsAndQuestionsObjId: activeNBA?.hintsAndQuestions?.filter(
                                                (hrq) =>
                                                  hrq?.questions?.find(
                                                    (q) =>
                                                      q?.id ===
                                                      questionOrHintEditMode,
                                                  ),
                                              )?.[0]?.id,
                                              questionId: questionOrHintEditMode,
                                              q: questionOrHintText,
                                            },
                                            () => {
                                              setQuestionOrHintEditMode(null);
                                              setQuestionOrHintText('');
                                              setUpdatingQuestionOrHint(false);
                                              setActiveNBA((prev) => {
                                                return {
                                                  ...prev,
                                                  hintsAndQuestions: [
                                                    {
                                                      ...(prev
                                                        ?.hintsAndQuestions?.[0] ||
                                                        {}),
                                                      questions: prev?.hintsAndQuestions?.[0]?.questions?.map(
                                                        (q) => {
                                                          if (
                                                            q?.id ===
                                                            questionOrHintEditMode
                                                          ) {
                                                            return {
                                                              ...q,
                                                              cq: questionOrHintText,
                                                            };
                                                          }
                                                          return q;
                                                        },
                                                      ),
                                                    },
                                                  ],
                                                };
                                              });
                                            },
                                            () => {},
                                          ),
                                        );
                                      }}
                                    />
                                  </Tooltip>
                                </>
                              )
                            ) : (
                              <>
                                <Tooltip arrow placement="top" title="Edit">
                                  <img
                                    src={'/dh-icons/edit.svg'}
                                    style={{
                                      cursor: 'pointer',
                                      width: 20,
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setQuestionOrHintEditMode(question?.id);
                                      setEditModeFor('question');
                                      setQuestionOrHintText(question?.cq);
                                    }}
                                  />
                                </Tooltip>
                              </>
                            )}
                          </Box>
                          <Close
                            sx={{
                              color: '#000',
                              cursor: 'pointer',
                              fontSize: 18,
                              position: 'absolute',
                              top: -5,
                              right: -5,
                              background: '#F2F6FC',
                              borderRadius: '50%',
                              border: '1px solid #C2DBFF',
                              padding: '2px',
                              zIndex: 1000,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              dispatch(
                                updateNextBestActions(
                                  dealId,
                                  activeArtifact?.id,
                                  activeNBA?.id,
                                  {
                                    hintsAndQuestionsObjId: activeNBA?.hintsAndQuestions?.filter(
                                      (hrq) =>
                                        hrq?.questions?.find(
                                          (q) => q?.id === question?.id,
                                        ),
                                    )?.[0]?.id,
                                    questionId: question?.id,
                                    questionDeleted: true,
                                  },
                                  () => {
                                    setActiveNBA((prev) => {
                                      return {
                                        ...prev,
                                        hintsAndQuestions: [
                                          {
                                            ...(prev?.hintsAndQuestions?.[0] ||
                                              {}),
                                            questions: questions?.filter(
                                              (q) => q?.id !== question?.id,
                                            ),
                                          },
                                        ],
                                      };
                                    });
                                  },
                                  () => {},
                                ),
                              );
                            }}
                          />
                        </>
                      )} */}
                    </Box>
                  </Box>
                </Box>
              ))}
              {hints?.map((hint, index) => (
                <Box
                  key={hint}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: readOnly ? 'default' : 'pointer',
                    borderRadius: 2,
                    width: 1,
                    gap: 1,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    // setActiveNBA(action);
                  }}
                >
                  <img
                    src="/dh-icons/lighbulb.svg"
                    width={'24px'}
                    height={'24px'}
                  />
                  <Box
                    sx={{
                      background: '#F2F6FC',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 1,
                      flex: 1,
                      borderRadius: 2,
                      // minHeight: 80,
                      // border: dq?.pinned
                      //   ? '1px solid #beb9e7'
                      //   : 'none',
                      position: 'relative',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        flex: 1,
                        borderRadius: 2,
                        paddingX: 2,
                      }}
                    >
                      {questionOrHintEditMode === hint ? (
                        <TextField
                          autoFocus
                          placeholder="Question"
                          variant="outlined"
                          color="primary"
                          size="small"
                          name="question"
                          multiline
                          rows={2}
                          value={questionOrHintText}
                          disabled={updatingQuestionOrHint}
                          onChange={(e) => {
                            setQuestionOrHintText(e.target.value);
                          }}
                          fullWidth
                        />
                      ) : (
                        <Box
                          display={'flex'}
                          flexDirection={'column'}
                          sx={{
                            width: 1,
                            padding: 1,
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography
                            sx={{
                              textDecoration: activeNBA?.deleted
                                ? 'line-through'
                                : 'none',
                            }}
                          >
                            {hint}
                          </Typography>
                        </Box>
                      )}
                      {/* {activeNBA?.deleted ? null : (
                        <>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 2,
                            }}
                          >
                            {questionOrHintEditMode === hint ? (
                              updatingQuestionOrHint ? (
                                <CircularProgress size={20} />
                              ) : (
                                <>
                                  <Tooltip title="Cancel" arrow placement="top">
                                    <Close
                                      sx={{
                                        cursor: 'pointer',
                                        fontSize: 20,
                                      }}
                                      onClick={() => {
                                        setQuestionOrHintEditMode(null);
                                        setQuestionOrHintText('');
                                      }}
                                    />
                                  </Tooltip>
                                  <Tooltip title="Save" arrow placement="top">
                                    <Check
                                      sx={{
                                        cursor: 'pointer',
                                        fontSize: 20,
                                      }}
                                      onClick={() => {
                                        setUpdatingQuestionOrHint(true);
                                        dispatch(
                                          updateNextBestActions(
                                            dealId,
                                            activeArtifact?.id,
                                            activeNBA?.id,
                                            {
                                              hintsAndQuestionsObjId: activeNBA?.hintsAndQuestions?.filter(
                                                (hrq) =>
                                                  hrq?.hints?.find(
                                                    (hint) =>
                                                      hint ===
                                                      questionOrHintEditMode,
                                                  ),
                                              )?.[0]?.id,
                                              hints: hints?.map((h) => {
                                                if (
                                                  h === questionOrHintEditMode
                                                ) {
                                                  return questionOrHintText;
                                                }
                                                return h;
                                              }),
                                            },
                                            () => {
                                              setQuestionOrHintEditMode(null);
                                              setQuestionOrHintText('');
                                              setUpdatingQuestionOrHint(false);
                                              setActiveNBA((prev) => {
                                                return {
                                                  ...prev,
                                                  hintsAndQuestions: [
                                                    {
                                                      ...(prev
                                                        ?.hintsAndQuestions?.[0] ||
                                                        {}),
                                                      hints: hints?.map((h) => {
                                                        if (
                                                          h ===
                                                          questionOrHintEditMode
                                                        ) {
                                                          return questionOrHintText;
                                                        }
                                                        return h;
                                                      }),
                                                    },
                                                  ],
                                                };
                                              });
                                            },
                                            () => {},
                                          ),
                                        );
                                      }}
                                    />
                                  </Tooltip>
                                </>
                              )
                            ) : (
                              <>
                                <Tooltip arrow placement="top" title="Edit">
                                  <img
                                    src={'/dh-icons/edit.svg'}
                                    style={{
                                      cursor: 'pointer',
                                      width: 20,
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setQuestionOrHintEditMode(hint);
                                      setEditModeFor('hint');
                                      setQuestionOrHintText(hint);
                                    }}
                                  />
                                </Tooltip>
                              </>
                            )}
                          </Box>
                          <Close
                            sx={{
                              color: '#000',
                              cursor: 'pointer',
                              fontSize: 18,
                              position: 'absolute',
                              top: -5,
                              right: -5,
                              background: '#F2F6FC',
                              borderRadius: '50%',
                              border: '1px solid #C2DBFF',
                              padding: '2px',
                              zIndex: 1000,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              dispatch(
                                updateNextBestActions(
                                  dealId,
                                  activeArtifact?.id,
                                  activeNBA?.id,
                                  {
                                    hintsAndQuestionsObjId: activeNBA?.hintsAndQuestions?.filter(
                                      (hrq) =>
                                        hrq?.hints?.find((h) => h === hint),
                                    )?.[0]?.id,
                                    hints: hints?.filter((h) => h !== hint),
                                  },
                                  () => {
                                    setActiveNBA((prev) => {
                                      return {
                                        ...prev,
                                        hintsAndQuestions: [
                                          {
                                            ...(prev?.hintsAndQuestions?.[0] ||
                                              {}),
                                            hints: hints?.filter(
                                              (h) => h !== hint,
                                            ),
                                          },
                                        ],
                                      };
                                    });
                                  },
                                  () => {},
                                ),
                              );
                            }}
                          />
                        </>
                      )} */}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </>
        ) : artifactProcessingStatuses?.includes(
            activeArtifact?.postProcessingStatus,
          ) ||
          artifactFailedStatuses?.includes(
            activeArtifact?.postProcessingStatus,
          ) ||
          Object.keys(artifactStatusMap || {})?.indexOf(
            activeArtifact?.postProcessingStatus,
          ) < 9 ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
              height: 1,
              width: 1,
              minHeight: 300,
              padding: 4,
              textAlign: 'center',
            }}
          >
            {artifactProcessingStatuses.includes(
              activeArtifact?.postProcessingStatus,
            ) ? (
              <CircularProgress size={20} />
            ) : null}
            <Typography variant="body1" color={'text.secondary'}>
              {artifactStatusMap[activeArtifact?.postProcessingStatus] || ''}
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              // width: 1,
              paddingBottom: 10,
              minHeight: 300,
              maxHeight: 350,
              padding: readOnly ? 2 : 1,
              // border: readOnly ? 'none' : '1px solid #d3d3d3',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 2,
            }}
          >
            <Typography color={'text.secondary'} mb={1}>
              Next Best Actions are not generated yet.
            </Typography>
            {/* <Button
              variant="outlined"
              onClick={() => {
                setActiveArtifactTab('detail');
                setTimeout(() => {
                  setCurrentArtifactDetailTab('risk');
                  scrollTo('artifactRiskSelection');
                }, 100);
              }}
            >
              Generate Now
            </Button> */}
          </Box>
        )}
      </Box>
    </Box>
  );
};

NextBestActions.propTypes = {
  type: PropTypes.string,
  dealId: PropTypes.string,
  dealArtifactsLoading: PropTypes.bool,
  noArtifacts: PropTypes.bool,
  readOnly: PropTypes.bool,
  activeArtifact: PropTypes.object,
  setCurrentArtifactDetailTab: PropTypes.func,
  setActiveArtifactTab: PropTypes.func,
};

export default NextBestActions;
